import React, { useContext, useState } from "react";
import { Form, Button, Image } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { get, isEmpty } from "lodash";
import { Formik } from "formik";
import {
  AddToolTip,
  FormLeaveGuard,
  LoaderWrapper,
  SliderPanel,
} from "../../../../../components";
import {
  ROUTES,
  usCurrency,
  formFields,
  getPathWithParam,
  managePayrollFormNames,
  scrollToErrorControl,
} from "../../../../../utils";
import FundingDetails from "./FundingDetails/FundingDetails";
import {
  retrieveBankDetails,
  getCustodianBankDetails,
  getForfeitureDetails,
  saveFundingDetailsByPlan,
  saveFundingByClassificationDetails,
  getAwaitingFundingDetailsByPlan,
  getFundingTransactionDetailsByPlan,
  getFundingTransactionDetailsByClassification,
  listFunding,
  retrievePayrollDetailsByFileId,
} from "../../../../../services";
import { useDeepEffect, useRequest } from "../../../../../abstracts";
import Cancel from "../../../../../styles/cancel.png";
import {
  faTimesCircle,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  managePayrollStore,
  setManagePayrollToastInfo,
} from "../../../../../contexts";

const initialValues = {
  bankFundings: [],
  forfeitureFundings: [],
  achDebitFundings: [],
};

const bankColumns = [
  {
    label: "Bank name",
    className: "column-bank-name",
    columnName: "bankName",
  },
  {
    label: "Available balance",
    className: "column-available-balance",
    columnName: "accountBalance",
  },
  {
    label: "Funding amount",
    className: "column-funding-amount",
    columnName: "bankFund",
  },
];

const forfeitureColumns = [
  {
    label: "Source Name",
    className: "column-forfeiture-type",
    columnName: "sourceName",
  },
  {
    label: "Available Balance",
    className: "column-forfeiture-balance",
    columnName: "forfeitureBalance",
  },
  {
    label: "Amount in File",
    className: "column-forfeiture-amount-file",
    columnName: "amountFile",
  },
  {
    label: "Funding Amount",
    className: "column-forfeiture-funding-amount",
    columnName: "forfeitureFund",
  },
];

const achDebitColumns = [
  {
    label: "Bank Name",
    className: "column-achDebit-type",
    columnName: "bankId",
  },
  {
    label: "Plan Account",
    className: "column-achDebit-type-plan-account",
    columnName: "planAccountId",
  },
  {
    label: "Funding Amount",
    className: "column-achDebit-funding-amount",
    columnName: "amount",
  },
];

const PayrollFundingDetails = ({
  data,
  fileId,
  toggle,
  setToggle,
  isPlan = false,
  isFundModalOpen,
  setFundModalOpen,
  classificationCodeId,
  classificationType,
  setViewByDisabled,
  triggerSlider,
  setTriggerSlider,
}) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const formName = managePayrollFormNames.FORFEITURE_FUNDING;
  const fields = formFields[formName];
  const { dispatch } = useContext(managePayrollStore);
  const [showDirtyCheckModal, setShowDirtyCheckModal] = useState(false);
  const [show, setShow] = useState({
    bank: false,
    forfeiture: false,
    ach: false,
  });
  const [total, setTotal] = useState(0);
  const [showErrors, setShowErrors] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);

  const { response: transDetailByFile } = useRequest({
    method: retrievePayrollDetailsByFileId,
    payload: fileId,
    defaultResponse: [],
  });

  const { response: transDetailByPlan, loading: isLoading1 } = useRequest({
    method: getFundingTransactionDetailsByPlan,
    payload: { planId: data.planId, fileId: fileId },
    defaultResponse: [],
  });
  const {
    response: transDetailByClassification,
    loading: isLoading2,
  } = useRequest({
    method: getFundingTransactionDetailsByClassification,
    payload: {
      classificationCodeId: classificationCodeId,
      planId: data.planId,
      fileId: fileId,
    },
    defaultResponse: [],
  });
  const { response: payrollBankDetails, loading } = useRequest({
    method: getCustodianBankDetails,
    payload: { planId: data.planId, fileId: fileId },
    defaultResponse: [],
  });

  const { response: payrollForfeitureDetails } = useRequest({
    method: getForfeitureDetails,
    payload: { fileId: fileId, planId: data.planId },
    defaultResponse: [],
  });

  const { response: achBankDetails } = useRequest({
    method: retrieveBankDetails,
    payload: data.planId,
    defaultResponse: [],
  });

  const {
    response: { funding },
    isLoading: fundingModeLoading,
  } = useRequest({
    method: listFunding,
    payload: data.planId,
    defaultResponse: [],
  });

  var tempData = [];
  tempData = payrollForfeitureDetails.map((item) => {
    const totalBalance = transDetailByPlan[0]?.transactionSourceDetails.find(
      (itm) => item.sourceId == itm.sourceId
    );
    return (item = {
      ...item,
      amountInFile: totalBalance?.amount,
    });
  });

  const amountData = payrollBankDetails?.map((i) => i.amount);
  const formValues = {
    fileId: parseInt(fileId),
    planId: data.planId,
    totalFundingAmount: data.totalFunding,
    totalEmployerContribution: data.employerContributionAmount,
    bankFundings: payrollBankDetails.map((i) => {
      return (i = {
        bankId: i.id,
        bankName: i.bankName,
        bankBalance: i.accountBalance,
        bankFund: i.amount,
        // amount: i.amount
      });
    }),

    forfeitureFundings: tempData?.map((i) => {
      return (i = {
        forfeitureId: i.id,
        forfeitureBalance: i.forfeitureBalance,
        amountInFile: i.amountInFile,
        forfeitureFund: i.amount,
      });
    }),
    achDebitFundings: achBankDetails?.map((i) => {
      return (i = {
        bankId: i.id,
        bankName: i.bankName,
        planAccountId: i.planAccountId,
        planAccountName: payrollBankDetails.find(
          (b) => b.id === i.planAccountId
        )?.bankName,
        amount: triggerSlider === false ? null : i.amount,
      });
    }),
  };

  const onFormToggle = (dirty) => {
    if (dirty) {
      setShowDirtyCheckModal(true);
    } else {
      setFundModalOpen(!isFundModalOpen);
    }
  };

  const handleConfirmClick = () => {
    setFundModalOpen(!isFundModalOpen);
  };

  const handleCancelClick = () => {
    setShowDirtyCheckModal(false);
  };

  useDeepEffect(() => {
    triggerSlider &&
      setShow({ ...show, bank: true, ach: true, forfeiture: true });
  }, [triggerSlider]);

  const onFormSubmit = (values, { setFieldError, setFieldTouched }) => {
    if (isPlan) {
      if (Object.values(show).every((value) => !value)) {
        setErrorMsg(true);
        setShowErrors(true);
      } else {
        setIsLoading(true);
        let updatedValues = {
          ...values,
          bankFundings: show.bank ? values.bankFundings : [],
          forfeitureFundings: show.forfeiture ? values.forfeitureFundings : [],
          achDebitFundings: show.ach
            ? [get(values.achDebitFundings, "0", [])]
            : [],
        };
        saveFundingDetailsByPlan(updatedValues)
          .then((response) => {
            setIsLoading(false);
            if (response.isSuccessfull) {
              if (response.isFunded) {
                dispatch(
                  setManagePayrollToastInfo({
                    showToast: true,
                    toastMessage: "File has been funded successfully",
                  })
                );
                triggerSlider
                  ? setTriggerSlider(false)
                  : history.push(
                      getPathWithParam({
                        path: ROUTES.PAYROLL,
                      })
                    );
                // triggerSlider && setTriggerSlider(false)

                triggerSlider == false && setToggle(!toggle);
                triggerSlider == false && setViewByDisabled(true);
                triggerSlider == false && setFundModalOpen(!isFundModalOpen);
              }
            } else {
              for (var i = 0; i < response.errorMessages.length; i++) {
                var _ = response.errorMessages[i];
                setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
                setFieldTouched(_.controlName, true);
                scrollToErrorControl(_.controlName);
              }
              setIsLoading(false);
            }
          })
          .catch((error) => {
            setIsLoading(false);
            //error
          });
      }
    } else {
      if (Object.values(show).every((value) => !value)) {
        setErrorMsg(true);
        setShowErrors(true);
      } else {
        setIsLoading(true);
        let updatedValues = {
          ...values,
          codeId: classificationCodeId,
          fundingType: classificationType,
          bankFundings: show.bank ? values.bankFundings : [],
          forfeitureFundings: show.forfeiture ? values.forfeitureFundings : [],
          achDebitFundings: show.ach ? values.achDebitFundings : [],
        };
        saveFundingByClassificationDetails(updatedValues)
          .then((response) => {
            setIsLoading(false);
            if (response.isSuccessfull) {
              if (response.isFunded) {
                dispatch(
                  setManagePayrollToastInfo({
                    showToast: true,
                    toastMessage: "File has been funded successfully",
                  })
                );
                history.push(
                  getPathWithParam({
                    path: ROUTES.PAYROLL,
                  })
                );
              }
              setToggle(!toggle);
              setViewByDisabled(true);
              setFundModalOpen(!isFundModalOpen);
            } else {
              for (var i = 0; i < response.errorMessages.length; i++) {
                var _ = response.errorMessages[i];
                setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
                setFieldTouched(_.controlName, true);
              }
              setIsLoading(false);
            }
          })
          .catch((error) => {
            setIsLoading(false);
            //error
          });
      }
    }
  };

  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          setFieldError,
          setFieldTouched,
          fieldValue,
          errors,
          dirty,
          ...rest
        } = formProps;

        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <LoaderWrapper
              isLoading={loading || isLoading || fundingModeLoading}
            >
              <div className="payroll-funding w-100" style={{ paddingTop: 0 }}>
                <div>
                  <div className="d-flex justify-content-between align-baseline">
                    <div className="plan-heading font-weight-500">
                      Allocate funds
                    </div>
                    <div className="d-flex mt-10">
                      <Button
                        variant={"secondary"}
                        onClick={() =>
                          triggerSlider
                            ? setTriggerSlider(false)
                            : onFormToggle(dirty)
                        }
                      >
                        Cancel
                      </Button>
                      {(show.bank || show.forfeiture || show.ach) && (
                        <div className={"ml-3"}>
                          <Button type={"submit"}>Allocate Funds</Button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="border-top" />
                  <div className="d-flex justify-content-start">
                    <div className="plan-header-text mr-0">
                      <p
                        className="ft-12 grey-text mb-1"
                        style={{ width: "255px" }}
                      >
                        Plan name
                      </p>
                      <p className="value"></p>
                      <AddToolTip name={data.planName} placement="bottom">
                        <span>{(data.planName || "").slice(0, 20)}...</span>
                      </AddToolTip>
                    </div>
                    <div className="plan-header-text">
                      <p className="ft-12 grey-text mb-1">Plan ID</p>
                      <p className="value" style={{ whiteSpace: "nowrap" }}>
                        {data.rkPlanNumber}
                      </p>
                    </div>
                    <div className="plan-header-text">
                      <p className="ft-12 grey-text mb-1">Employees</p>
                      <p className="value">{data.employeesCount}</p>
                    </div>
                    <div className="plan-header-text">
                      <p className="ft-12 grey-text mb-1">Total funding</p>
                      <p className="value">{usCurrency(data.totalFunding)}</p>
                    </div>
                    <div className="plan-header-text">
                      <p
                        className="ft-12 grey-text mb-1"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Total Employer Contribution
                      </p>
                      <p className="value">
                        {usCurrency(data.employerContributionAmount)}
                      </p>
                    </div>
                  </div>
                  <div className="border-top" />
                </div>
                {funding?.planCashAccountEnabled && (
                  <FundingDetails
                    triggerSlider={triggerSlider}
                    setTriggerSlider={setTriggerSlider}
                    data={payrollBankDetails}
                    title={"Funding via Bank"}
                    columns={bankColumns}
                    setTotal={setTotal}
                    show={show}
                    setShow={setShow}
                    isBank={true}
                    fieldArrayName={fields.bankFundings}
                    errors={errors.funding}
                  />
                )}
                {funding?.forfeitureAccountEnabled && (
                  <FundingDetails
                    data={payrollForfeitureDetails}
                    triggerSlider={triggerSlider}
                    setTriggerSlider={setTriggerSlider}
                    title={"Funding via Forfeiture"}
                    columns={forfeitureColumns}
                    fieldArrayName={fields.forfeitureFundings}
                    setTotal={setTotal}
                    show={show}
                    setShow={setShow}
                    isForfeiture={true}
                    errors={errors.forfeiture}
                    transDetailByPlan={transDetailByPlan}
                  />
                )}
                {funding?.achAccountEnabled && (
                  <FundingDetails
                    data={[1]}
                    triggerSlider={triggerSlider}
                    setTriggerSlider={setTriggerSlider}
                    title={"Funding via ACH Debit"}
                    columns={achDebitColumns}
                    fieldArrayName={fields.achDebitFundings}
                    achBankDetails={achBankDetails}
                    setTotal={setTotal}
                    show={show}
                    errors={errors.amount}
                    setShow={setShow}
                    isAch={true}
                    payrollBankDetails={payrollBankDetails}
                  />
                )}
                <div class="bottom-fixed mb-2">
                  <div className="border-top-dashed" />
                  <div className="d-flex justify-content-between plan-heading font-weight-500 mb-0">
                    <div>Total amount</div>
                    <div className="mr-5">{usCurrency(total)}</div>
                  </div>
                  {!isEmpty(errors) && errors.totalFundingAmount !== undefined && (
                    <span className="d-flex justify-content-end ft-14 error-text">
                      <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        color="#f16973"
                        className="mt-1 mr-1"
                      />
                      {errors.totalFundingAmount}
                    </span>
                  )}
                </div>
              </div>
              {showErrors && (
                <div
                  className={`error-banner justify-content-between d-flex align-items-center ${
                    (showErrors && "enable") || "enable"
                  }`}
                >
                  <div>
                    <Image src={Cancel} width="30px" />
                  </div>
                  <div>
                    <div className="error-heading">
                      {errorMsg ? "" : "Oops"}
                    </div>
                    <div className="error-reason">
                      {errorMsg ? (
                        <span>
                          Please enter the funding amount, to <br />
                          complete the funding process
                        </span>
                      ) : (
                        "Something Went wrong"
                      )}
                    </div>
                  </div>
                  <div>
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      color="#000"
                      style={{ fontSize: "14px" }}
                      onClick={() => {
                        setShowErrors(false);
                      }}
                    />
                  </div>
                </div>
              )}
            </LoaderWrapper>
            <FormLeaveGuard
              showModal={showDirtyCheckModal}
              handleConfirmClick={handleConfirmClick}
              handleCancelClick={handleCancelClick}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default PayrollFundingDetails;
